import { ReactComponent as LettuceIcon } from './lettuce.svg';

export default LettuceIcon;
